<template>
  <page-main
    ref="main"
    :tableData="tableData"
    :disabled="disabled"
    @delRow="delRow"
  >
    <page-header ref="header" slot="header" />
  </page-main>
</template>

<script>
import PageMain from './main'
import PageHeader from './header'
export default {
  components: {
    PageHeader,
    PageMain,
  },
  props: {
    tableData: { type: Array, default: () => [] },
    disabled: {
      default: true,
      type: Boolean,
    },
  },
  data() {
    return {
      usePage: false,
    }
  },
  methods: {
    delRow(rowId) {
      this.$emit('delRow', rowId)
    },
  },
}
</script>
